<template>
    <el-popover
      placement="top-start"
      trigger="hover"
      popper-class="dbs-tickborne-popover info-popover-wrap"
      :width="190"
    >
      <template #default>
        <div class="info-popover-content">{{ infoText }}</div>
      </template>
      <template v-slot:reference>
        <span class="material-icons-outlined" style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle; pointer-events: auto; cursor: pointer;">
          info
        </span>
      </template>
    </el-popover>
</template>

<script>
export default {
  name: 'TestInfoIconPopover',
  props: {
    infoText: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>
.info-popover-content {
  white-space: pre-line;
}
</style>
